module.exports = __webpack_public_path__ + "components/about-header/static/header--large@2x-3c491f270020908177643a56155d08d7.jpg";